/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { FonticulusTraunchTwo } from "../FonticulusTraunchTwo";

export class FonticulusTraunchTwo__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    router_: string,
    wrappedPTGAddress_: string,
    wrappedMaticAddress_: string,
    overrides?: Overrides
  ): Promise<FonticulusTraunchTwo> {
    return super.deploy(
      router_,
      wrappedPTGAddress_,
      wrappedMaticAddress_,
      overrides || {}
    ) as Promise<FonticulusTraunchTwo>;
  }
  getDeployTransaction(
    router_: string,
    wrappedPTGAddress_: string,
    wrappedMaticAddress_: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      router_,
      wrappedPTGAddress_,
      wrappedMaticAddress_,
      overrides || {}
    );
  }
  attach(address: string): FonticulusTraunchTwo {
    return super.attach(address) as FonticulusTraunchTwo;
  }
  connect(signer: Signer): FonticulusTraunchTwo__factory {
    return super.connect(signer) as FonticulusTraunchTwo__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FonticulusTraunchTwo {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as FonticulusTraunchTwo;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "router_",
        type: "address",
      },
      {
        internalType: "address",
        name: "wrappedPTGAddress_",
        type: "address",
      },
      {
        internalType: "address",
        name: "wrappedMaticAddress_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [],
    name: "ONE_HUNDRED_PERCENT",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PERP_CONTRACTS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minPTGAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "addLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minPTGAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
    ],
    name: "addLiquidityMATIC",
    outputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "claimLiquidity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "emergencyRemoveIncentives",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
    ],
    name: "outPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "percentMatched",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
    ],
    name: "price",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "percentage",
        type: "uint32",
      },
    ],
    name: "setMatchPercentage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokens",
    outputs: [
      {
        internalType: "address",
        name: "uniswapPool",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "depositedAt",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "userTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
